import React, { Fragment } from 'react';
import { Link, useParams } from 'react-router-dom'
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle';
import Projects from '../../api/projects';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo.jpeg'
import VideoModal from '../../components/ModalVideo/VideoModal';

const ProjectData = () => {
    const { slug } = useParams()

    const ProjectData = Projects.find(item => item.slug === slug)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    if (!ProjectData) {
        return <h2 style={{ textAlign: 'center', marginTop: '100px' }}>Project Not Found</h2>
    }

    return (
        <Fragment>
            <NavbarS4 
                hclass={'wpo-site-header wpo-header-style-s11'} 
                Logo={Logo} 
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} 
            />

            <PageTitle pageTitle={ProjectData.title} pagesub={'Project Details'} />

            <section className="project-single-page">
                <div className="container-fluid">
                    <div className="project-image scroll-text-animation" data-animation="fade_from_bottom">
                        <img src={ProjectData.sing} alt={ProjectData.title} />
                    </div>

                    <div className="row align-items-center">
                        <div className="col-lg-8 col-12">
                            <div className="content">
                                <h2 className="scroll-text-animation" data-animation="fade_from_bottom">
                                    {ProjectData.title}
                                </h2>

                                {ProjectData.intro.map((para, index) => (
                                    <p key={index}>{para}</p>
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-4 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="description">
                                <h3>Project Info:</h3>
                                <ul>
                                    <li><span>Project :</span> <span>{ProjectData.subtitle}</span></li>
                                    <li><span>Architect :</span> <span>{ProjectData.architect}</span></li>
                                    <li><span>Client :</span> <span>{ProjectData.client}</span></li>
                                    {/* <li><span>Duration :</span> <span>{ProjectData.date}</span></li>
                                    <li><span>Budget :</span> <span>{ProjectData.budget}</span></li> */}
                                    <li><span>Location :</span> <span>{ProjectData.location}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="solve-section">
                <div className="container-fluid">
                   <div className="project-title">
    <div className="row align-items-center">
        <div className="col-lg-6 col-12">
            <h2 className="scroll-text-animation" data-animation="fade_from_bottom">
                Architectural Innovation in Action
            </h2>
        </div>
        <div className="col-lg-6 col-12">
            <p className="scroll-text-animation" data-animation="fade_from_bottom">
                From concept to completion, we address complex challenges through creative design thinking, technical expertise, and meticulous execution that exceeds expectations.
            </p>
        </div>
    </div>
</div>

                    <div className="image-wrap">
                        <div className="row">
                            {ProjectData.solveImages.map((img, index) => (
                                <div key={index} className="col-lg-4 col-md-6 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                                    <div className="image">
                                        <img src={img} alt="" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="summery-section">
                <div className="container-fluid">
                    <div className="project-title">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-12">
                                <h2 className="scroll-text-animation" data-animation="fade_from_bottom">
                                    Project Summary & Solutions
                                </h2>
                            </div>
                            <div className="col-lg-6 col-12">
                                <p className="scroll-text-animation" data-animation="fade_from_bottom">
                                    Each project is executed with a detailed understanding of client requirements, site conditions, and long-term usability.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="wraper" style={{ backgroundImage: `url(${ProjectData.videoBg})` }}>
                        <div className="video-wrap">
                            <div className="video-holder">
                                <VideoModal />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="RelatedProject-section">
                <div className="container-fluid">
                    <div className="project-title">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-12">
                                <h2 className="scroll-text-animation" data-animation="fade_from_bottom">
                                    Related Projects
                                </h2>
                            </div>
                            <div className="col-lg-6 col-12">
                                <p className="scroll-text-animation" data-animation="fade_from_bottom">
                                    Explore other projects that reflect our architectural excellence and design philosophy.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="item-wrap">
  <div className="row">
    {Projects.filter(p => p.slug !== slug)
      .slice(0, 3)
      .map((project, index) => (
        <div
          key={index}
          className="col-lg-4 col-md-6 col-12 scroll-text-animation"
          data-animation="fade_from_bottom"
        >
          <div className="item">
            <div
              className="image"
              style={{
                width: "100%",
                height: "260px",
                position: "relative",
                overflow: "hidden"
              }}
            >
              <img
                src={project.pimg}
                alt={project.title}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "100%",
                  height: "100%",
                  transform: "translate(-50%, -50%)",
                  objectFit: "cover",
                  display: "block"
                }}
              />
            </div>

            <div className="content">
              <h2>
                <Link
                  onClick={ClickHandler}
                  to={`/project-single/${project.slug}`}
                >
                  {project.title}
                </Link>
              </h2>
              <span>{project.subtitle}</span>
            </div>
          </div>
        </div>
      ))}
  </div>
</div>

                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ProjectData;
